import packageJson from "../../package.json";

export const FEES_TYPE = {
  LANDING: "LANDING",
  SECURITY: "SECURITY",
  PARKING: "PARKING",
  OVERTIME: "OVERTIME",
  ESCORT: "ESCORT",
};
export const TRIP_PHASE = {
  ARRIVAL: "ARRIVAL",
  DEPARTURE: "DEPARTURE",
};

export const AIRPORT_TYPE = {
  INTL: "INTL",
  DOM: "DOM",
};

export const TRIP_REQUEST_TAB = {
  ALL: "ALL",
  SPECIAL_ONBOARDING: "SPECIAL_ONBOARDING",
  AFTER_HOURS: "AFTER_HOURS",
  AUTO_GENERATED: "AUTO_GENERATED",
  MANUALLY_CREATED: "MANUALLY_CREATED",
};

/** Maps trip request tab to createdByAdsb API param (only for AUTO_GENERATED / MANUALLY_CREATED). */
export const TRIP_REQUEST_TAB_CREATED_BY_ADSB = {
  [TRIP_REQUEST_TAB.AUTO_GENERATED]: true,
  [TRIP_REQUEST_TAB.MANUALLY_CREATED]: false,
};

const CONSTANTS = {
  FEES_TYPE,
};

export default CONSTANTS;

export const TRIP_STATUS = {
  READY_TO_PAY: "READY_TO_PAY",
  CANCELLED: "CANCELLED",
  CORRECTION_REQUESTED: "CORRECTION_REQUESTED",
  CORRECTION_DONE: "CORRECTION_DONE",
  COMPLETED: "COMPLETED",
  PAID: "PAID",
};
export const ClearanceStatus = {
  NOT_REQUIRED: "NOT_REQUIRED",
  CLEARANCE_REQUESTED: "CLEARANCE_REQUESTED",
  CLEARANCE_GRANTED: "READY_TO_PAY",
  CORRECTION_REQUESTED: "CORRECTION_REQUESTED",
  CORRECTION_DONE: "CORRECTION_DONE",
  CLEARANCE_REJECTED: "CLEARANCE_REJECTED",
  CANCELLED: "CANCELLED",
  PAID: "PAID",
};
export const getStatusInfo = (status) => {
  switch (status) {
    case ClearanceStatus.CLEARANCE_REQUESTED:
      return { text: "Pending", className: "pending" };
    case ClearanceStatus.CLEARANCE_GRANTED:
      return { text: "Approved", className: "approved" };
    case ClearanceStatus.PAID:
      return { text: "Approved", className: "approved" };
    case ClearanceStatus.CORRECTION_REQUESTED:
      return {
        text: "Correction Requested",
        className: "correction-requested",
      };
    case ClearanceStatus.CORRECTION_DONE:
      return { text: "Correction Done", className: "correction-done" };
    case ClearanceStatus.CLEARANCE_REJECTED:
      return { text: "Cancelled", className: "rejected" };
    case ClearanceStatus.CANCELLED:
      return { text: "Cancelled", className: "rejected" };
    default:
      return { text: "", className: "" };
  }
};
export const DefaultConfigValues = {
  REACT_APP_KEYCLOAK_URL: "https://keycloak.airportauthority.net/",
  REACT_APP_KEYCLOAK_REALM: "Airport-Authority",
  REACT_APP_KEYCLOAK_CLIENT_ID: "landing-auth-web-app",
  REACT_APP_API_URL: "https://services.airportauthority.net/",
  REACT_APP_VERSION: packageJson.version,
  REACT_APP_SENTRY_DSN: "https://a32174b31342667679db091146d5b14f@o4509546647519232.ingest.us.sentry.io/4509558786424832",
};
export const ValidationMessages = {
  ESCORT_ARRIVAL_APPROVAL_REQUIRED:
    "Before approving the trip, you need to approve Special Onboarding.",
  ESCORT_DEPARTURE_APPROVAL_REQUIRED:
    "Before approving the trip, you need to approve Special Onboarding.",
  AFTER_HOURS_APPROVAL_REQUIRED:
    "Before approving the trip, you need to approve after hours.",
};

export const TRIP_DETAILS_ACTION_MESSAGES = {
  DEPARTURE_DATE_NOT_ARRIVED:
    "Approve and Correction Needed buttons will be enabled once the departure date arrives.",
  NO_ARRIVAL_AIRPORT_ACCESS:
    "You don't have access to the arrival airport, so you're not authorized to Approve this trip.",
  NO_DEPARTURE_AIRPORT_ACCESS:
    "You don't have access to the departure airport, so you're not authorized to Approve this trip.",
  NON_PAYMENT_ADSB_TRIP:
    "This is a non-payment ADS-B trip, so you're not authorized to Approve this trip.",
  NON_PAYMENT_TRIP:
    "This is a non-payment trip, so you're not authorized to Approve this trip.",
};

export const TRIP_STATUS_FOR_FILTER = [
  { value: "COMPLETED", label: "Completed" },
  { value: "CANCELLED", label: "Cancelled" },
  { value: "EXEMPTED", label: "Exempted" },
];

export const ERROR_MESSAGE = {
  UNAUTHORIZE_ACCESS:
    "You don't have permission to perform any action. Contact your administrator.",
  UNAUTHORIZE_ACCESS_PROFILE: "Unauthorized access. User profile not found.",
  API_FAILED: "API request failed",
  PAST_DATE_FILTER_NOT_ALLOWED: "Upcoming trips cannot be filtered for past dates!",
  FUTURE_DATE_FILTER_NOT_ALLOWED: "Historic trips cannot be filtered for future dates!",
};

export const REJECT_REASONS = {
  AIRPORT_CLOSED: "AIRPORT_CLOSED",
  OFFICERS_NOT_AVAILABLE: "OFFICERS_NOT_AVAILABLE",
};

export const OVERRIDDEN_MTOW_STATUS = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
};
export const handleAircraftType = (item) => {
  if (item && item !== "") {
    if (item === "PISTON") {
      return "PROP (PISTON)";
    } else if (item === "TURBOPROP") {
      return "PROP (TURBOPROP)";
    } else if (item === "TURBOSHAFT") {
      return "PROP (TURBOSHAFT)";
    } else {
      return item;
    }
  }
  return "---";
};

export const CORRECTION_OPTIONS = [
  {
    value: "UPDATE_PASSENGER_INFORMATION",
    label: "Update Passenger Information",
  },
  {
    value: "UPDATE_VEHICLE_INFORMATION",
    label: "Update Vehicle Information",
  },
  {
    value: "UPDATE_PASSENGER_AND_VEHICLE_INFORMATION",
    label: "Update Passenger and Vehicle Information",
  },
];
export const TRIP_CORRECTION_OPTIONS_SINGLE_SELECTION = [
  {
    value: "PASSENGER_NOT_INITIALLY_INCLUDED",
    label: "Passenger Not Initially Included",
  },
  {
    value: "PASSENGER_NO_LONGER_TRAVELING",
    label: "Passenger No Longer Traveling",
  },
];

export const TRIP_CORRECTION_OPTIONS_MULTIPLE_SELECTION = [
  {
    value: "ARRIVAL_TERMINAL_REQUIRED",
    label: "Update Arrival Terminal Information",
  },
  {
    value: "DEPARTURE_TERMINAL_REQUIRED",
    label: "Update Departure Terminal Information",
  },
  {
    value: "PASSENGER_REQUIRED",
    label: "Add Missing Passengers",
  },
];

// Keep for backward compatibility
export const TRIP_CORRECTION_OPTIONS = [
  ...TRIP_CORRECTION_OPTIONS_SINGLE_SELECTION,
  ...TRIP_CORRECTION_OPTIONS_MULTIPLE_SELECTION,
];

export const CORRECTION_REASON_VALUES = {
  ARRIVAL_TERMINAL_REQUIRED: "ARRIVAL_TERMINAL_REQUIRED",
  DEPARTURE_TERMINAL_REQUIRED: "DEPARTURE_TERMINAL_REQUIRED",
  PASSENGER_REQUIRED: "PASSENGER_REQUIRED",
};

export const CORRECTION_REASON_ENUM = {
  DEPARTURE_AND_ARRIVAL_TERMINALS_REQUIRED: "DEPARTURE_AND_ARRIVAL_TERMINALS_REQUIRED",
  DEPARTURE_TERMINAL_AND_PASSENGER_REQUIRED: "DEPARTURE_TERMINAL_AND_PASSENGER_REQUIRED",
  ARRIVAL_TERMINAL_AND_PASSENGER_REQUIRED: "ARRIVAL_TERMINAL_AND_PASSENGER_REQUIRED",
  DEPARTURE_ARRIVAL_TERMINALS_AND_PASSENGER_REQUIRED: "DEPARTURE_ARRIVAL_TERMINALS_AND_PASSENGER_REQUIRED",
};

export const EXEMPTION_REASONS = {
  AIRCRAFT_ENGAGED_IN_RESCUE: "AIRCRAFT_ENGAGED_IN_RESCUE",
  AIRCRAFT_PROVIDING_MEDICAL_EMERGENCY: "AIRCRAFT_PROVIDING_MEDICAL_EMERGENCY",
  AIRCRAFT_EMERGENCY_LANDING: "AIRCRAFT_EMERGENCY_LANDING",
  AIRCRAFT_OWNED_BY_GOVERNMENT: "AIRCRAFT_OWNED_BY_GOVERNMENT",
  AIRCRAFT_CHARTED_BY_GOVERNMENT: "AIRCRAFT_CHARTED_BY_GOVERNMENT",
  AIRCRAFT_BELONGING_TO_ARMED_FORCE: "AIRCRAFT_BELONGING_TO_ARMED_FORCE",
  AIRCRAFT_BELONGING_TO: "AIRCRAFT_BELONGING_TO",
};

export const EXEMPTION_REASON_OPTIONS = [
  {
    value: EXEMPTION_REASONS.AIRCRAFT_ENGAGED_IN_RESCUE,
    label: "Aircraft engaged in search and rescue operations",
  },
  {
    value: EXEMPTION_REASONS.AIRCRAFT_PROVIDING_MEDICAL_EMERGENCY,
    label: "Aircraft providing emergency medical services",
  },
  {
    value: EXEMPTION_REASONS.AIRCRAFT_EMERGENCY_LANDING,
    label: "Aircraft performing an emergency landing at an airport other than its intended destination",
  },
  {
    value: EXEMPTION_REASONS.AIRCRAFT_OWNED_BY_GOVERNMENT,
    label: "Aircraft owned by the Government",
  },
  {
    value: EXEMPTION_REASONS.AIRCRAFT_CHARTED_BY_GOVERNMENT,
    label: "Aircraft chartered by the Government",
  },
  {
    value: EXEMPTION_REASONS.AIRCRAFT_BELONGING_TO_ARMED_FORCE,
    label: "Aircraft belonging to the armed forces",
  },
  {
    value: EXEMPTION_REASONS.AIRCRAFT_BELONGING_TO,
    label: "Aircraft belonging to governments of ICAO member states",
  },
];
export const AUTO_APPROVAL_MESSAGE =
  "Auto approved since no Action taken on Landing Authorization by the officer.";

export const APP_NAME = 'aa-landing-app';
export const VERSION_KEY = `${APP_NAME}:lastSeenVersion`;

// Creator constants
export const CREATOR_TYPES = {
  SYSTEM: 'System'
};

// Sentry configuration constants
export const LOCALHOST_HOSTNAMES = [
  'localhost',
  '127.0.0.1',
  '0.0.0.0'
];
